import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import I18n from 'I18n';
// @ts-expect-error migrate downstream
import { getName } from 'dashboard-lib/public/dashboard/dashboard-schema';
// @ts-expect-error migrate downstream
import bust from 'reporting-data/bust';
import { Header } from 'foundations-components/transitional/components/Header';
import { View } from 'foundations-components/components/View';
// @ts-expect-error migrate downstream
import { fetchDashboard } from '../../actions/DashboardActions';
// @ts-expect-error migrate downstream
import { getWidgetsWithDefault } from 'dashboard-lib/public/dashboard/dashboard-logic';
// @ts-expect-error migrate downstream
import { removeEmailConfirmBar } from '../shared/EmailConfirmBar';
// @ts-expect-error migrate downstream
import WidgetGrid from './WidgetGrid';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { withRouter } from 'react-router-dom';
import compose from 'transmute/compose';
import { connect } from 'react-redux';
// @ts-expect-error migrate downstream
import { INCREMENT_FORCE_RENDER_COUNT } from '../../ducks/forceRenderCount';
// @ts-expect-error migrate downstream
import { getDashboardBaseUrl } from 'dashboard-components/lib/urlHelpers';
import { RemoveIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PresentationMode extends PureComponent {
  constructor(props) {
    super(props);
    this.defaultExitPresentationMode = () => {
      const {
        dashboardId
      } = this.props;
      window.location.href = `${getDashboardBaseUrl()}/view/${dashboardId}`;
    };
    this.updateDashboard = () => {
      const {
        dashboardId
      } = this.props;
      fetchDashboard(dashboardId);
      bust();
      this.props.incrementForceRenderCount();
    };
    this.renderHeaderControls = () => {
      const {
        exitPresentationMode
      } = this.props;
      return /*#__PURE__*/_jsx(IconButton, {
        use: "link",
        "aria-label": I18n.text('presentationMode.exit'),
        onClick: exitPresentationMode || this.defaultExitPresentationMode,
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      });
    };
    this.renderWidgetGrid = () => {
      const {
        dashboard
      } = this.props;
      if (!dashboard) {
        return null;
      }
      return /*#__PURE__*/_jsx(WidgetGrid, {
        dashboard: dashboard,
        widgets: getWidgetsWithDefault(dashboard),
        canEditWidgets: false,
        isPresentation: true
      });
    };
    this.render = () => {
      const {
        dashboard
      } = this.props;
      return /*#__PURE__*/_jsxs(View, {
        minBlockSize: "100%",
        backgroundColor: "fill-surface-raised",
        children: [/*#__PURE__*/_jsx(View, {
          backgroundColor: "fill-surface-default",
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(Header, {
            title: getName(dashboard),
            children: this.renderHeaderControls()
          })
        }), this.renderWidgetGrid()]
      });
    };
    removeEmailConfirmBar();
  }
  componentDidMount() {
    // @ts-expect-error migrate ts todo
    this.interval = setInterval(this.updateDashboard, 600000);
    window.addEventListener('online', this.updateDashboard);
  }
  componentWillUnmount() {
    // @ts-expect-error migrate ts todo
    clearInterval(this.interval);
    window.removeEventListener('online', this.updateDashboard);
  }
}
PresentationMode.propTypes = {
  incrementForceRenderCount: PropTypes.func.isRequired,
  // @ts-expect-error migrate ts todo
  dashboard: PropTypes.instanceOf(ImmutableMap),
  dashboardId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  history: PropTypes.object.isRequired,
  exitPresentationMode: PropTypes.func
};
export default compose(withRouter, connect(() => {}, dispatch => ({
  incrementForceRenderCount: () => dispatch(INCREMENT_FORCE_RENDER_COUNT())
})))(PresentationMode);